/** Locale-aware number formatting for points and counts. */
export function num(n: number | null | undefined, locale: string): string {
  return n === null || n === undefined ? "—" : new Intl.NumberFormat(locale).format(n);
}

export function pct(x: number | null | undefined, digits = 0): string {
  return x === null || x === undefined ? "—" : `${(x * 100).toFixed(digits)}%`;
}

export function dateTime(iso: string | null | undefined, locale: string): string {
  if (!iso) return "—";
  return new Intl.DateTimeFormat(locale, { dateStyle: "medium", timeStyle: "short" }).format(new Date(iso));
}

export function minutes(sec: number, locale: string): string {
  return new Intl.NumberFormat(locale, { style: "unit", unit: sec < 60 ? "second" : "minute", maximumFractionDigits: 0 }).format(
    sec < 60 ? sec : Math.round(sec / 60),
  );
}
